export default __webpack_public_path__ + "static/media/okr-empty.2aa53864.svg";